import { FETCH_WIX_DATA_SUCCESS } from './fetch-wix-data';
import { SET_WIX_DATA_SUCCESS } from './set-wix-data';
export const INITIAL_STATE = {};
const wixData = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case FETCH_WIX_DATA_SUCCESS:
        case SET_WIX_DATA_SUCCESS:
            return {
                ...state,
                ...action.payload,
            };
        default:
            return state;
    }
};
export default wixData;
//# sourceMappingURL=wix-data.js.map